import { Routes } from '@angular/router';
import { MainLayoutComponent } from './shared/layouts/main-layout/main-layout.component';
import { content } from './shared/routes/content.route';
import { AuthenticationLayoutComponent } from './shared/layouts/authentication-layout/authentication-layout.component';
import { authen } from './shared/routes/auth.route';
import { LandingLayoutComponent } from './shared/layouts/landing-layout/landing-layout.component';
import { custom } from './shared/routes/customer.routes';
import { CustomerLayoutComponent } from './shared/layouts/customer-layout/customer-layout.component';
import { LoginAuthGuard } from './componets/authentication/login-guard.guard';

export const App_Route: Routes = [
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
  {
    path: 'auth/login',
    // canActivate: [LoginAuthGuard],
    loadComponent: () =>
      import('../app/authentication/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'organiser/login',
    // canActivate: [LoginAuthGuard],
    loadComponent: () =>
      import('../app/authentication/organiser-login/organiser-login.component').then((m) => m.OrganiserLoginComponent),
  },
  { path: '', component: MainLayoutComponent, children: content },
  { path: '', component: CustomerLayoutComponent, children: custom },
  { path: '', component: AuthenticationLayoutComponent, children: authen },
  { path: '', component: LandingLayoutComponent, children: authen },
];
